const styles = {
  card: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    borderRadius: '20px',
    templateGridColumns: 'auto auto',
    templateGridRows: 'auto auto',
    minHeight: '450px',
    marginBottom: '30px',
    backgroundColor: '#112340',
    color: '#ffffff',
    width: {
      xs: '97%',
      lg: '90%',
    },
    marginLeft: 'auto',
    marginRight: 'auto',
  },
};

export default styles;
